import { render } from "./NavButton.vue?vue&type=template&id=4c604fca&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"

import "./NavButton.vue?vue&type=style&index=0&id=4c604fca&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c604fca"]])

export default __exports__